<div class="mu-container">
  <div class="mu-header">
    <div class="mu-title-row">
      <button mat-icon-button (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
      <h2 class="mu-title">Usuários do Comerciante</h2>
    </div>
    <button mat-raised-button color="primary" (click)="openCreate()">
      <mat-icon>add</mat-icon> Cadastrar Usuário
    </button>
  </div>

  <div *ngIf="loading" class="mu-loading">
    <mat-spinner [diameter]="36"></mat-spinner>
  </div>

  <div [hidden]="loading">
    <mat-card>
      <table mat-table [dataSource]="users" class="mu-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let u">{{ u.firstName }} {{ u.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-mail</th>
          <td mat-cell *matCellDef="let u">{{ u.email }}</td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef>Telefone</th>
          <td mat-cell *matCellDef="let u">{{ u.phone }}</td>
        </ng-container>
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef>Sexo</th>
          <td mat-cell *matCellDef="let u">{{ u.gender || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let u">
            <button mat-icon-button (click)="openEdit(u)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="confirmDelete(u)" matTooltip="Remover">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <p *ngIf="!loading && users.length === 0" class="mu-empty">Nenhum usuário cadastrado.</p>
    </mat-card>
  </div>
</div>
